import React, {ReactNode, useEffect, useRef, useState} from 'react';
import { Bubble } from 'tea-component'

import './index.scss'

interface Props {
  content: ReactNode // 浮窗内容
  maxWidth?: number // 显示省略号的最大宽度
  ellipsisContent?: string // 计算省略号的内容
}

const BubbleEllipsis = (props: Props) => {
  const { content, maxWidth=110, ellipsisContent=content } = props;
  const ref = useRef(null)
  const [flag, setFlag] = useState(true)
  useEffect(() => {
    if (ref && ref.current) {
      const box = ref.current
      if (+box.offsetWidth >= maxWidth) {
        setFlag(false)
      }
    }
  }, [props])
  return (
        flag ?
          <span ref={ref}>{ellipsisContent}</span> :
          <Bubble
            arrowPointAtCenter
            placement="top"
            dark
            content={content}
          >
            <span className='insightBubble'  >{ellipsisContent}</span>
          </Bubble>
  )
}

export default BubbleEllipsis